import api from "./axios";
import type { ShareLink, PublicShareLinkInfo, ApiMessage } from "@/types";

interface CreateShareLinkDto {
  fileIds: string[];
  password?: string;
  expiresAt?: string;
  maxDownloads?: number;
}

export const createShareLink = (dto: CreateShareLinkDto) =>
  api.post<ShareLink>("/share-links", dto).then((r) => r.data);

export const getShareLinks = () => api.get<ShareLink[]>("/share-links").then((r) => r.data);

export const getShareLink = (id: string) =>
  api.get<ShareLink>(`/share-links/${id}`).then((r) => r.data);

export const deactivateShareLink = (id: string) =>
  api.delete<ApiMessage>(`/share-links/${id}`).then((r) => r.data);

export const getPublicShareLink = (token: string) =>
  api.get<PublicShareLinkInfo>(`/share-links/public/${token}`).then((r) => r.data);

export const downloadFromShareLink = (token: string, password?: string) =>
  api
    .post(`/share-links/public/${token}/download`, { password }, { responseType: "blob" })
    .then((r) => r.data);
